<span [innerHTML]="textoMostrado"></span>

<span
  *ngIf="necesitaLeerMas"
  class="leer-mas ms-1 text-iguau"
  (click)="toggle()">

  {{ mostrarTextoCompleto ? 'Leer menos' : 'Leer más' }}

</span>